import {TopToolbar,} from 'react-admin';
import CreateCategoryButton from "resources/questionCategory/list/components/CreateCategoryButton";
import CreateTagButton from "resources/questionCategory/list/components/CreateTagButton";
import CreateSubcategoryButton from "resources/questionCategory/list/components/CreateSubcategoryButton";


const QuestionCategoryActions = () => {
  return (
    <TopToolbar>
      <CreateTagButton/>
      <CreateCategoryButton/>
      <CreateSubcategoryButton/>
    </TopToolbar>
  )
}

export default QuestionCategoryActions;
